import { API_URL, API_KEY, FILTER_SERVICE } from '../configs/global';

export const FETCH_GET_ROUTES = 'FETCH_GET_ROUTES';

export const fetchGetRoutes = () => {
  const url = `${API_URL}/all-routes-v1?api_key=${API_KEY}${FILTER_SERVICE ? '&only_service_classes=' + FILTER_SERVICE : ''}`;

  return (dispatch) => {
    fetch(url)
      .then((response) => response.json())
      .then((response) =>
        dispatch({
          type: FETCH_GET_ROUTES,
          payload: response,
        })
      )
      .catch((error) => console.log(error));
  };
};



// WEBPACK FOOTER //
// ./src/actions/GetRoutesAction.js